import React from 'react';
import styles from './InteraktivXizmatlar.module.css';

const InteraktivXizmatlar = () => {
    return (
        <div className={styles.mainContainer}>
            <div className={styles.container}>
                <div className={styles.titleWrapper}>
                    <h2 className={styles.title}>
                        🎓 Talabalar uchun qulaylik! <br /> Yangi Telegram bot ishga tushirildi
                    </h2>
                </div>

                <div className={styles.contentBox}>
                    <p className={styles.paragraph}>
                        Renessans ta’lim universiteti Registrator ofisi tomonidan talabalarga yanada sifatli va tezkor xizmat ko‘rsatish maqsadida <strong>yangi Telegram bot ishga tushirildi.</strong>
                    </p>

                    <p className={styles.paragraph}>
                        Endilikda talabalar quyidagi xizmatlardan <strong>onlayn tarzda, oson va qulay foydalanishlari mumkin:</strong>
                    </p>

                    <ul className={styles.serviceList}>
                        <li>📌 To‘lov-kontrakt shartnomasini olish</li>
                        <li>📌 O‘qish joyidan ma’lumotnoma</li>
                        <li>📌 HEMIS AT tizimiga kirish uchun login va parol</li>
                        <li>📌 Akademik ma’lumotnoma (transkript)</li>
                        <li>📌 Sirtqi ta’lim shakli uchun chaqiruv qog‘ozi</li>
                        <li>📌 O‘quv binolarining joylashuvi</li>
                        <li>📌 O‘quv jarayoni grafigi bo‘yicha ma’lumot (sirtqi ta’lim uchun)</li>
                    </ul>

                    <p className={styles.highlightParagraph}>
                        💡 Ushbu bot orqali ortiqcha vaqt sarflamasdan, barcha zarur hujjatlar va ma’lumotlarni tezkor tarzda olish imkoniyati yaratildi.
                    </p>

                    <p className={styles.finalParagraph}>
                        🚀 <strong>Raqamli xizmatlar — sizning qulayligingiz uchun!</strong>
                    </p>

                    <div className={styles.actionContainer}>
                        <a href="https://t.me/renessans_talim_bot" target="_blank" rel="noopener noreferrer" className={styles.botButton}>
                            Botga o'tish
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InteraktivXizmatlar;
